import { SERVER_BASE_URL } from '../config/api.config';

export const login = async (username, password) => {
  const response = await fetch(`${SERVER_BASE_URL}/api/auth/login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include', // Important: send cookies with request
    body: JSON.stringify({ username, password }),
  });

  const data = await response.json();
  if (!data.success) {
    throw new Error(data.message || 'Login failed');
  }

  // Token is now stored in httpOnly cookie by server
  // Set flag that we should be logged in
  localStorage.setItem('shouldBeLoggedIn', 'true');

  return true; // Success
};

export const logout = async () => {
  try {
    // Cookie is sent automatically with credentials: 'include'
    await fetch(`${SERVER_BASE_URL}/api/auth/logout`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include', // Send cookies with request
    });
  } finally {
    // Clear the shouldBeLoggedIn flag to indicate explicit logout
    localStorage.removeItem('shouldBeLoggedIn');

    // Redirect to login page
    window.location.href = '/login';
  }
};

export const getToken = () => {
  // Token is stored in httpOnly cookie, not accessible to JavaScript
  // This is a security feature to prevent XSS attacks
  // Return login status instead
  return localStorage.getItem('shouldBeLoggedIn') === 'true';
};

export const clearToken = () => {
  // Token is cleared by server when logout endpoint is called
  // Just clear local flags
  localStorage.removeItem('shouldBeLoggedIn');
};

export const isAuthenticated = () => {
  // Check if user should be logged in
  // The server will validate the actual cookie on API requests
  return localStorage.getItem('shouldBeLoggedIn') === 'true';
}; 